<template>
    <div class="justify-content-center mb-5">

        <div class="row justify-content-center">
            <div class="col-md-5 my-4">
                <p class="fts-20 m-emphasis text-center">Sélectionnez une plateforme pour obtenir une comparaison immédiate</p>
                <div class="mx-auto my-3" style="width: 250px;">
                    <select
                        class="form-control-4"
                        style="font-size: 11px; max-width: 250px; text-transform: capitalize; border: 1px solid rgba(187, 134, 252, .2)!important;"
                        v-model="alternative">
                        <option value="null" disabled>Alternative</option>
                        <option v-for="(alternative, index) in contract.alternatives" :key="index" :value="alternative">{{ alternative.platform_name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-4 element-x-ray m-2" style="border: 1px solid rgba(255, 255, 255, .12);">
                <div style="">
                    <p class="fts-18 light-blue-01" style="font-weight: 900;"><span style="text-transform: uppercase;">{{ contract.portfolio.platform_contract_name }}</span></p>
                    <p class="fts-16 light-white-03">Votre solde sur ce contrat : <span style="font-weight: 900;" class="light-blue-01">{{ Math.round(contract.portfolio.amount,0) }} €</span></p>
                    <p class="fts-16 light-white-03">Coût total de ce contrat : <span style="font-weight: 900;" class="light-blue-01">{{ Math.round(contract.portfolio.cost.total,0) }} €</span></p>
                    <p class="fts-16 light-white-03">Coût total de ce contrat avec les frais de versements : <span style="font-weight: 900;" class="light-blue-01">{{ Math.round(contract.portfolio.cost.total_with_deposit,0) }} €</span></p>
                    <div class="mb-3" style="border-bottom: 1px solid rgba(255, 255, 255, .12);"></div>
                    <p class="fts-16 m-emphasis mb-1">Dans le détail :</p>
                    <p class="fts-14 light-white-03 mb-1">Droits de garde : <span style="font-weight: 900;" class="light-blue-01">{{ Math.round(contract.portfolio.cost.platform_management,0) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais de transaction : <span style="font-weight: 900;" class="light-blue-01">{{ Math.round(contract.portfolio.cost.platform_transaction,0) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais de gestion sur les titres (fonds, ETFs) : <span style="font-weight: 900;" class="light-blue-01">{{ Math.round(contract.portfolio.cost.securities_management,0) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais d'entrée sur les titres (fonds) : <span style="font-weight: 900;" class="light-blue-01">{{ Math.round(contract.portfolio.cost.securities_entry,0) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-3">Frais de versements (unique) : <span style="font-weight: 900;" class="light-blue-01">{{ Math.round(contract.portfolio.cost.deposit,0) }} €</span></p>
                </div>
                <div class="text-left">
                    <button class="btn-alt-4" v-b-modal="modalId(contract.portfolio.platform_contract_name)">
                        Votre portefeuille actuel
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-circle ml-1" style= "margin-bottom: 2px;" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                    </button>
                </div>
                <b-modal
                    title="Votre portefeuille actuel"
                    class="modal fade alt-list" :id="'modal' + contract.portfolio.platform_contract_name"
                    tabindex="-1"
                    role="dialog"
                    size="xl"
                    aria-labelledby="alternatives"
                    aria-hidden="true"
                    :header-bg-variant="headerBgVariant"
                    :header-text-variant="headerTextVariant"
                    :body-bg-variant="bodyBgVariant"
                    :body-text-variant="bodyTextVariant"
                    :footer-bg-variant="footerBgVariant"
                    :footer-text-variant="footerTextVariant"
                    ok-only
                    >
                    <div>
                        <table class="myfotable-dark">
                            <colgroup>
                                <col style="width: 12.5%;">
                                <col style="width: 12.5%;">
                                <col style="width: 12.5%;">
                                <col style="width: 12.5%;">
                                <col style="width: 12.5%;">
                                <col style="width: 12.5%;">
                                <col style="width: 12.5%;">
                                <col style="width: 12.5%;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th style="text-align: left;">Position</th>
                                    <th style="text-align: left;">Contrat</th>
                                    <th>Allocation</th>
                                    <th>Nombre de parts</th>
                                    <th>ISIN</th>
                                    <th>Frais de gestion</th>
                                    <th>Frais d'entrée</th>
                                    <th>Ratio de Sharpe</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(security, i) in contract.portfolio.securities" :key="i">
                                    <div style="display: contents;" id="random">
                                        <td style="font-weight: bold; color: #635bff; text-align: left;">
                                            {{ security.name }}
                                        </td>
                                        <td style="font-weight: bold; color: #635bff; text-align: left;">
                                            {{ contract.portfolio.contract_name }}
                                        </td>
                                        <td style="font-weight: bold; color: #635bff;">
                                            {{ Math.round(security.amount) }} €
                                        </td>
                                        <td style="font-weight: bold; color: #635bff;">
                                            {{ Math.round(security.shares) }}
                                        </td>
                                        <td>
                                            {{ security.isin }}
                                        </td>
                                        <td>{{ Math.round(security.management_fees*100,2)/100 }} %</td>
                                        <td>{{ Math.round(security.entry_fees*100,2)/100 }} %</td>
                                        <td>{{ Math.round(security.sharpe_ratio*100)/100 }}</td>
                                    </div>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-modal>
            </div>
            <div class="col-md-4 element-x-ray m-2" style="border: 1px solid rgba(255, 255, 255, .12);">
                <div style="">
                    <p class="fts-18" style="font-weight: 900; color: #bb86fc;"><span style="text-transform: capitalize;">{{ alternative.contract_name }}</span> chez <span style="text-transform: capitalize;">{{ alternative.platform_name }}</span></p>
                    <p class="fts-16 light-white-03">Coût du contrat total : <span style="font-weight: 900; color: #bb86fc;">{{ Math.round(alternative.cost.total,0) }} €</span></p>
                    <p class="fts-16 light-white-03">Coût du contrat total avec frais de versements : <span style="font-weight: 900; color: #bb86fc;">{{ Math.round(alternative.cost.total_with_deposit,0) }} €</span></p>
                    <div class="mb-3" style="border-bottom: 1px solid rgba(255, 255, 255, .12);"></div>
                    <p class="fts-16 m-emphasis mb-1">Dans le détail :</p>
                    <p class="fts-14 light-white-03 mb-1">Droits de garde : <span style="font-weight: 900; color: #bb86fc;">{{ Math.round(alternative.cost.platform_management,0) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais de transaction : <span style="font-weight: 900; color: #bb86fc;">{{ Math.round(alternative.cost.platform_transaction,0) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais de gestion sur les titres (fonds, ETFs) : <span style="font-weight: 900; color: #bb86fc;">{{ Math.round(alternative.cost.securities_management,0) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-1">Frais d'entrée sur les titres (fonds) : <span style="font-weight: 900; color: #bb86fc;">{{ Math.round(alternative.cost.securities_entry,0) }} €</span></p>
                    <p class="fts-14 light-white-03 mb-3">Frais de versements (unique) : <span style="font-weight: 900; color: #bb86fc;">{{ Math.round(alternative.cost.platform_deposit,0) }} €</span></p>

                    <div class="text-left">
                        <button class="btn-alt-2 mb-3" v-b-modal="modalId(alternative.platform_contract_name)">
                            Votre portefeuille potentiel
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-circle ml-1" style= "margin-bottom: 2px;" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                            </svg>
                        </button>
                    </div>
                    <div class="text-left mt-3">
                        <a target="_blank" rel="noopener" class="btn-transparncy mb-4 ml-0 mt-0" style="display: inline-block;" :href="alternative.affiliation_url">Changer de contrat</a>
                        <p class="fts-14 m-emphasis mb-0" v-if="alternative.discount_upfront != null">Ouvrez ce contrat et bénéficiez d'une prime de <span style="text-transform: capitalize;font-weight: bold; color: rgb(187, 134, 252);">{{alternative.discount_upfront}} €</span> si vous investissez <span style="text-transform: capitalize;" class="h-emphasis">{{alternative.discount_upfront_requirement}} €</span></p>
                        <p class="fts-14 m-emphasis mb-0" v-else-if="alternative.discount_transaction != null">Ouvrez ce contrat et bénéficiez d'une économie d'au moins {{alternative.discount_transaction * alternative.transaction_min_price}} € en passant vos ordres.</p>
                        <p class="fts-14 m-emphasis mb-0" style="display: inline-block;" v-if="alternative.transfer_included != 0">
                            <svg width="29" height="29" aria-label="clap" class="mb-1" fill="currentColor">
                                <g fill-rule="evenodd">
                                    <path d="M13.74 1l.76 2.97.76-2.97zM16.82 4.78l1.84-2.56-1.43-.47zM10.38 2.22l1.84 2.56-.41-3.03zM22.38 22.62a5.11 5.11 0 0 1-3.16 1.61l.49-.45c2.88-2.89 3.45-5.98 1.69-9.21l-1.1-1.94-.96-2.02c-.31-.67-.23-1.18.25-1.55a.84.84 0 0 1 .66-.16c.34.05.66.28.88.6l2.85 5.02c1.18 1.97 1.38 5.12-1.6 8.1M9.1 22.1l-5.02-5.02a1 1 0 0 1 .7-1.7 1 1 0 0 1 .72.3l2.6 2.6a.44.44 0 0 0 .63-.62L6.1 15.04l-1.75-1.75a1 1 0 1 1 1.41-1.41l4.15 4.15a.44.44 0 0 0 .63 0 .44.44 0 0 0 0-.62L6.4 11.26l-1.18-1.18a1 1 0 0 1 0-1.4 1.02 1.02 0 0 1 1.41 0l1.18 1.16L11.96 14a.44.44 0 0 0 .62 0 .44.44 0 0 0 0-.63L8.43 9.22a.99.99 0 0 1-.3-.7.99.99 0 0 1 .3-.7 1 1 0 0 1 1.41 0l7 6.98a.44.44 0 0 0 .7-.5l-1.35-2.85c-.31-.68-.23-1.19.25-1.56a.85.85 0 0 1 .66-.16c.34.06.66.28.88.6L20.63 15c1.57 2.88 1.07 5.54-1.55 8.16a5.62 5.62 0 0 1-5.06 1.65 9.35 9.35 0 0 1-4.93-2.72zM13 6.98l2.56 2.56c-.5.6-.56 1.41-.15 2.28l.26.56-4.25-4.25a.98.98 0 0 1-.12-.45 1 1 0 0 1 .29-.7 1.02 1.02 0 0 1 1.41 0zm8.89 2.06c-.38-.56-.9-.92-1.49-1.01a1.74 1.74 0 0 0-1.34.33c-.38.29-.61.65-.71 1.06a2.1 2.1 0 0 0-1.1-.56 1.78 1.78 0 0 0-.99.13l-2.64-2.64a1.88 1.88 0 0 0-2.65 0 1.86 1.86 0 0 0-.48.85 1.89 1.89 0 0 0-2.67-.01 1.87 1.87 0 0 0-.5.9c-.76-.75-2-.75-2.7-.04a1.88 1.88 0 0 0 0 2.66c-.3.12-.61.29-.87.55a1.88 1.88 0 0 0 0 2.66l.62.62a1.88 1.88 0 0 0-.9 3.16l5.01 5.02c1.6 1.6 3.52 2.64 5.4 2.96a7.16 7.16 0 0 0 1.18.1c1.03 0 2-.25 2.9-.7A5.9 5.9 0 0 0 23 23.24c3.34-3.34 3.08-6.93 1.74-9.17l-2.87-5.04z"></path>
                                </g>
                            </svg>
                            Bonne nouvelle, les frais de transfert chez <span style="text-transform: capitalize;">{{alternative.platform_name}}</span> sont pris en charge.
                        </p>
                    </div>
                    <b-modal
                        title="Ce à quoi pourrait ressembler votre portefeuille"
                        class="modal fade alt-list" :id="'modal' + alternative.platform_contract_name"
                        tabindex="-1"
                        role="dialog"
                        size="xl"
                        aria-labelledby="alternatives"
                        aria-hidden="true"
                        :header-bg-variant="headerBgVariant"
                        :header-text-variant="headerTextVariant"
                        :body-bg-variant="bodyBgVariant"
                        :body-text-variant="bodyTextVariant"
                        :footer-bg-variant="footerBgVariant"
                        :footer-text-variant="footerTextVariant"
                        ok-only
                        >
                        <div>
                            <table class="myfotable-dark">
                                <colgroup>
                                    <col style="width: 16.6%;">
                                    <col style="width: 16.6%;">
                                    <col style="width: 16.6%;">
                                    <col style="width: 16.6%;">
                                    <col style="width: 16.6%;">
                                    <col style="width: 16.6%;">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th style="text-align: left;">Position</th>
                                        <th>ISIN</th>
                                        <th>Frais de gestion</th>
                                        <th>Frais d'entrée</th>
                                        <th>Économie potentielle</th>
                                        <th>Ratio de Sharpe</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(security, i) in alternative.securities" :key="i">
                                        <!--<div v-if="alternative.platform_contract.id === array.portfolio.platform_contract.platform_contract.id" style="display: contents;" id="random">-->
                                            <td style="font-weight: bold; color: rgb(187, 134, 252); text-align: left;">
                                                {{ security.name }}
                                                <span style="color: rgb(255, 255, 255, .87)">au lieu de</span> <span style="color: #635bff">{{ contract.portfolio.securities[i].name }}</span>
                                            </td>
                                            <td style="font-weight: bold; color: rgb(187, 134, 252);">
                                                {{ security.isin }}
                                            </td>
                                            <td style="font-weight: bold; color: rgb(187, 134, 252);">{{ Math.round(security.management_fees*100,2)/100 }} %</td>
                                            <td style="font-weight: bold; color: rgb(187, 134, 252);">{{ Math.round(security.entry_fees*100,2)/100 }} %</td>
                                            <td style="font-weight: bold; color: rgb(187, 134, 252);">{{ Math.round(security.savings,2) }} €</td>
                                            <td style="font-weight: bold; color: rgb(187, 134, 252);">{{ Math.round(security.sharpe_ratio*10)/10 }} </td>
                                        <!--</div>-->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-modal>
                </div>
            </div>
            <div class="col-md-3 element-x-ray m-2" style="border: 1px solid rgba(255, 255, 255, .12);">
                <div style="">
                    <p class="fts-18" style="font-weight: 900; color: #03dac5;">Pour résumer, vous économisez :</p>
                    <p class="fts-16 light-white-03"><span style="font-weight: 900; color: #03dac5;">{{ Math.round((alternative.savings.total),0) }} €</span> au total sur ce contrat</p>
                    <p class="fts-16 light-white-03"><span style="font-weight: 900; color: #03dac5;">{{ Math.round((alternative.savings.total_with_deposit),0) }} €</span> au total sur ce contrat (frais de versements et frais d'entrée inclus)</p>
                    <div class="mb-3" style="border-bottom: 1px solid rgba(255, 255, 255, .12);"></div>
                    <p class="fts-16 m-emphasis mb-1">Dans le détail :</p>
                    <p class="fts-14 light-white-03 mb-1"><span style="font-weight: 900; color: #03dac5;">{{ Math.round(alternative.savings.platform_management,0) }} €</span> sur les droits de garde</p>
                    <p class="fts-14 light-white-03 mb-1"><span style="font-weight: 900; color: #03dac5;">{{ Math.round(alternative.savings.platform_transaction,0) }} €</span> sur les frais de transaction</p>
                    <p class="fts-14 light-white-03 mb-1"><span style="font-weight: 900; color: #03dac5;">{{ Math.round(alternative.savings.securities_management,0) }} €</span> sur les les frais de gestion sur les titres</p>
                    <p class="fts-14 light-white-03 mb-1"><span style="font-weight: 900; color: #03dac5;">{{ Math.round(alternative.savings.securities_entry,0) }} €</span> sur les les frais d'entrée sur les titres</p>
                    <p class="fts-14 light-white-03 mb-3"><span style="font-weight: 900; color: #03dac5;">{{ Math.round(alternative.savings.platform_deposit,0) }} €</span> sur les les frais de versements</p>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'contract',
            'token',
            'route',
        ],
        data() {
            return {
                alternative: this.contract.alternatives[0],
                customs:[],
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        methods: {
            modalId(i) {
            return 'modal' + i;
            },
    }
}


</script>